import Vue from 'vue'
import Vuex from 'vuex'

// 根级别存储
import state from './state.js'
import actions from './actions.js'
import mutations from './mutations.js'

// 模块存储
import modules from './modules'

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  mutations,
  actions,
  modules
});